var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketingLaunch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.0895 110.767C92.1952 110.767 87.6826 110.767 83.1701 110.767C73.0168 110.767 62.8592 110.767 52.7059 110.767C50.9043 110.767 49.892 111.514 49.8448 112.843C49.7976 114.233 50.8529 115.082 52.7145 115.082C67.9981 115.091 83.2816 115.099 98.5651 115.061C99.8134 115.061 100.611 115.37 101.358 116.425C103.64 119.641 106.037 122.781 108.427 125.921C111.215 129.588 115.685 130.042 119.198 127.04C120.21 126.174 121.179 125.256 122.162 124.355C125.315 121.469 125.722 117.634 123.165 114.169C118.94 108.434 114.677 102.726 110.43 97.0083C110.155 96.6394 109.898 96.262 109.606 95.8503C110.494 95.2198 111.524 95.0568 112.437 94.6279C112.905 94.4092 113.295 94.4821 113.729 94.7523C120.622 99.0542 126.395 104.398 129.282 112.209C132.976 122.215 130.355 130.99 123.676 138.878C123.183 139.461 122.616 139.388 122.016 139.388C115.247 139.388 108.474 139.388 101.705 139.388C96.5748 139.388 93.7308 142.232 93.6965 147.383C93.6837 149.433 93.6493 151.487 93.7137 153.538C93.7437 154.503 93.392 154.897 92.4654 155.06C85.4607 156.287 78.4259 156.712 71.3396 156.034C70.3101 155.935 69.4822 156.158 68.6286 156.754C60.9161 162.176 53.1778 167.563 45.4352 172.941C44.8862 173.323 44.3628 174.082 43.5564 173.559C42.6856 172.993 43.1918 172.191 43.3591 171.47C44.8819 164.895 46.3832 158.316 47.9532 151.753C48.2234 150.621 48.0261 150.064 46.9151 149.54C41.1543 146.821 36.0283 143.21 31.8889 138.307C22.5549 127.259 22.7866 113.495 32.5023 102.764C39.1425 95.4299 47.6057 91.1452 56.9354 88.3573C59.8265 87.4953 62.7734 86.8519 65.7675 86.3973C66.7155 86.2557 66.7627 86.5688 66.7026 87.3494C65.9391 97.6302 72.3691 105.895 82.5438 107.581C85.8853 108.134 89.2011 107.705 92.3282 106.337C93.1989 105.955 93.6536 106.028 94.1855 106.834C95.0177 108.104 95.9871 109.283 97.0938 110.767H97.0895ZM78.0141 126.761C69.5594 126.761 61.1005 126.761 52.6459 126.761C50.84 126.761 49.8534 127.516 49.8448 128.871C49.8362 130.222 50.8357 131.007 52.6201 131.046C52.826 131.05 53.0319 131.046 53.2335 131.046C69.7353 131.046 86.2371 131.046 102.739 131.042C103.348 131.042 103.978 131.042 104.566 130.896C105.647 130.63 106.23 129.841 106.153 128.747C106.076 127.662 105.385 126.98 104.304 126.787C103.858 126.706 103.387 126.757 102.923 126.757C94.6188 126.757 86.3186 126.757 78.0141 126.757V126.761Z",
    fill: "url(#paint0_linear_25_519)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.014 143.707C123.552 143.707 129.089 143.703 134.631 143.707C136.901 143.707 137.99 144.69 138.003 146.933C138.037 155.189 138.037 163.446 138.003 171.702C137.994 173.937 136.901 174.979 134.631 174.983C123.556 175.004 112.476 175.004 101.401 174.983C99.0199 174.983 97.9261 173.855 97.9218 171.47C97.9089 163.368 97.9089 155.266 97.9218 147.164C97.9218 144.754 98.9941 143.712 101.401 143.712C106.938 143.703 112.476 143.712 118.018 143.712L118.014 143.707ZM111.88 159.277C111.88 160.915 111.854 162.553 111.888 164.188C111.918 165.676 112.412 166.002 113.66 165.303C116.56 163.681 119.438 162.022 122.295 160.332C123.47 159.637 123.479 158.998 122.325 158.316C119.421 156.6 116.5 154.919 113.561 153.259C112.459 152.637 111.94 152.929 111.897 154.207C111.841 155.893 111.884 157.582 111.88 159.272V159.277Z",
    fill: "url(#paint1_linear_25_519)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.512 44.3091C124.255 57.7166 131.95 71.0511 139.736 84.5358C135.464 84.8875 131.406 85.2521 127.391 86.0284C120.892 87.2851 114.578 89.1551 108.457 91.647C107.239 92.1403 106.715 91.8872 106.085 90.7721C102.121 83.781 98.089 76.8242 94.0355 69.8845C93.5593 69.0696 93.5636 68.615 94.34 68.0016C102.808 61.3193 110.297 53.7192 116.118 44.575C116.165 44.4978 116.281 44.4635 116.512 44.3177V44.3091Z",
    fill: "url(#paint2_linear_25_519)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9152 66.1747C37.7956 66.2605 36.6503 66.625 35.6937 67.4914C34.7629 68.3364 33.875 68.2549 33.0128 67.3542C32.1635 66.4663 31.2927 65.5914 30.4048 64.7422C29.564 63.9358 29.371 63.0866 30.216 62.203C33.1329 59.1707 30.9839 53.7494 26.6729 53.7708C25.5662 53.7751 25.0386 53.0117 25.0129 51.9437C24.9871 50.6613 24.9914 49.3832 25.0086 48.1007C25.0257 46.8955 25.5705 46.2693 26.8573 46.1321C31.0997 45.6689 32.9828 41.3026 30.3662 37.9529C29.4868 36.8292 29.5083 35.9843 30.5249 35.0407C31.4257 34.2043 32.2793 33.3122 33.1415 32.4415C33.9265 31.6481 34.6857 31.6695 35.5865 32.3257C39.3656 35.1007 43.3934 33.428 44.0025 28.8216C44.1527 27.6893 44.7746 27.1832 45.8256 27.1489C47.1553 27.106 48.4894 27.106 49.8234 27.1489C50.973 27.1832 51.5349 27.8137 51.6722 28.9803C52.1955 33.3336 56.4121 35.1007 59.9424 32.4201C60.959 31.6481 61.7525 31.6438 62.619 32.5487C63.5027 33.4752 64.4206 34.3716 65.33 35.2766C66.1193 36.0615 66.1879 36.9278 65.4372 37.7213C62.4217 40.8866 64.7423 46.0892 68.9503 46.1664C70.0098 46.1835 70.5503 46.8012 70.5761 47.8177C70.6104 49.2502 70.6061 50.687 70.5761 52.1196C70.5546 53.1575 69.9455 53.6507 68.9375 53.8009C64.2619 54.5 62.6619 58.3558 65.4544 62.203C66.1021 63.0909 66.1107 63.8801 65.33 64.6607C64.3863 65.6042 63.4469 66.5478 62.5032 67.4871C61.7139 68.2677 60.929 68.2334 60.041 67.5858C56.2191 64.785 52.38 66.3977 51.655 71.1071C51.5006 72.1193 50.9902 72.7026 49.9521 72.724C48.5709 72.7498 47.1854 72.754 45.7998 72.7326C44.6245 72.7154 44.1012 72.1107 43.9854 70.9183C43.7108 68.1348 41.669 66.2347 38.9066 66.1833L38.9152 66.1747ZM47.8931 39.0552C41.9178 39.0295 36.9677 43.8803 36.9163 49.8164C36.8605 55.851 41.7205 60.8177 47.7559 60.8949C53.6968 60.9678 58.7842 55.9111 58.7627 49.9579C58.737 44.0047 53.8298 39.0809 47.8974 39.0552H47.8931Z",
    fill: "url(#paint3_linear_25_519)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.152 35.6024C117.152 32.094 119.086 29.4777 121.93 28.6285C124.907 27.7407 127.965 28.8644 129.617 31.6351C132.186 35.9413 134.657 40.3075 137.166 44.648C143.721 55.9925 150.258 67.3455 156.834 78.6814C158.194 81.0232 158.558 83.3736 157.263 85.8226C156.062 88.1044 154.08 89.3096 151.549 89.3782C148.885 89.4511 146.809 88.233 145.458 85.9084C142.069 80.0667 138.698 74.2122 135.322 68.362C129.69 58.6131 124.066 48.8598 118.426 39.1152C117.692 37.8499 117.13 36.5632 117.156 35.6024H117.152Z",
    fill: "url(#paint4_linear_25_519)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1175 103.481C78.6403 103.391 73.1412 99.2516 71.3954 93.1483C69.6109 86.9164 72.0216 80.4099 77.5422 76.9787C81.1068 74.7656 84.8087 72.7712 88.4204 70.6267C89.1497 70.1935 89.4413 70.3607 89.8231 71.0255C94.2585 78.7544 98.7067 86.4746 103.181 94.1777C103.575 94.8554 103.571 95.1899 102.846 95.5974C99.1871 97.6561 95.5668 99.7792 91.9078 101.838C89.8102 103.017 87.5196 103.511 85.1175 103.485V103.481Z",
    fill: "url(#paint5_linear_25_519)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.392 138.548C146.23 138.604 144.15 137.789 142.237 136.523C140.602 135.443 140.156 133.688 141.087 131.951C142.057 130.146 143.073 128.366 144.158 126.629C145.244 124.892 146.998 124.476 148.834 125.393C153.124 127.542 153.604 127.422 156.521 123.558C159.193 120.019 161.321 116.185 162.848 112.02C163.766 109.507 163.315 108.224 161.042 106.891C157.76 104.965 157.417 103.631 159.339 100.303C160.107 98.973 160.84 97.6219 161.651 96.3181C162.796 94.4738 164.478 94.0449 166.417 95.0399C171.105 97.4547 173.271 101.534 172.787 106.543C171.598 118.797 165.842 128.657 156.036 136.09C153.878 137.724 151.348 138.591 148.392 138.543V138.548Z",
    fill: "url(#paint6_linear_25_519)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.6 118.685C120.549 120.731 115.86 124.857 113.96 124.685C113.068 124.604 112.425 124.145 111.914 123.467C107.178 117.149 102.46 110.819 97.7072 104.518C97.2139 103.862 97.4027 103.609 98.0161 103.266C100.47 101.885 102.919 100.487 105.334 99.0412C105.99 98.6509 106.372 98.6552 106.848 99.3029C111.198 105.205 115.577 111.081 119.944 116.969C120.347 117.514 120.587 118.132 120.6 118.685Z",
    fill: "url(#paint7_linear_25_519)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.075 38.1289C146.582 38.0989 145.441 36.5549 146.149 35.2381C147.83 32.09 149.628 29.0019 151.485 25.9524C152.124 24.9059 153.256 24.7257 154.312 25.3991C155.341 26.0553 155.723 27.0633 155.097 28.1784C153.428 31.1636 151.704 34.1144 149.988 37.0696C149.572 37.7815 148.915 38.1418 148.079 38.1289H148.075Z",
    fill: "url(#paint8_linear_25_519)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.807 59.0636C169.441 59.0636 171.075 59.0336 172.709 59.0722C174.091 59.1065 175.009 60.0115 174.996 61.2295C174.983 62.4433 174.061 63.344 172.675 63.3569C169.406 63.3869 166.138 63.3869 162.865 63.3569C161.449 63.344 160.553 62.5034 160.519 61.2681C160.48 59.9771 161.398 59.0979 162.899 59.0679C164.534 59.0336 166.168 59.0593 167.802 59.0636H167.807Z",
    fill: "url(#paint9_linear_25_519)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.393 40.698C171.358 41.4701 170.925 42.1349 170.166 42.5723C167.468 44.1421 164.774 45.7291 162.046 47.2474C160.862 47.9079 159.536 47.5262 159.026 46.4239C158.477 45.2401 158.751 44.185 159.897 43.5073C162.629 41.8947 165.37 40.2863 168.154 38.768C169.651 37.9531 171.341 38.9567 171.393 40.6937V40.698Z",
    fill: "url(#paint10_linear_25_519)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.643 54.7401C152.652 56.2112 152.193 57.5451 151.463 58.8061C151.056 59.5052 150.747 59.7282 150.241 58.8361C148.182 55.1904 146.089 51.5619 143.974 47.9505C143.189 46.6081 144.313 46.8869 144.888 46.8826C149.117 46.8311 152.656 50.4425 152.643 54.7444V54.7401Z",
    fill: "url(#paint11_linear_25_519)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25_519",
    x1: 78.0062,
    y1: 86.3643,
    x2: 78.0062,
    y2: 173.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_25_519",
    x1: 117.97,
    y1: 143.706,
    x2: 117.97,
    y2: 174.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_25_519",
    x1: 116.723,
    y1: 44.3091,
    x2: 116.723,
    y2: 91.8875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_25_519",
    x1: 47.7974,
    y1: 27.1167,
    x2: 47.7974,
    y2: 72.7463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_25_519",
    x1: 137.609,
    y1: 28.3306,
    x2: 137.609,
    y2: 89.3813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_25_519",
    x1: 87.1291,
    y1: 70.3872,
    x2: 87.1291,
    y2: 103.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_25_519",
    x1: 156.73,
    y1: 94.5181,
    x2: 156.73,
    y2: 138.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_25_519",
    x1: 109.013,
    y1: 98.7764,
    x2: 109.013,
    y2: 124.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_25_519",
    x1: 150.667,
    y1: 25.0015,
    x2: 150.667,
    y2: 38.1293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_25_519",
    x1: 167.757,
    y1: 59.0503,
    x2: 167.757,
    y2: 63.3794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_25_519",
    x1: 165.073,
    y1: 38.4805,
    x2: 165.073,
    y2: 47.5724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_25_519",
    x1: 148.174,
    y1: 46.8613,
    x2: 148.174,
    y2: 59.4215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingLaunch);
export default __webpack_public_path__ + "static/media/Marketing_&_Launch.47a77fd7c9b1db1f97391bf51a01cb33.svg";
export { ForwardRef as ReactComponent };